import React from "react";
import { Button } from "react-bootstrap";
import { useLanguage } from "../i18n/LanguageContext";

interface TwoFAButtonProps {
  enabled: boolean;
  onClick: () => void;
  className?: string;
}

const TwoFAButton: React.FC<TwoFAButtonProps> = ({
  enabled,
  onClick,
  className = "",
}) => {
  const { t } = useLanguage();

  if (enabled) {
    return (
      <Button
        variant="success"
        onClick={onClick}
        className={`d-flex align-items-center gap-2 ${className}`}
        style={{
          borderRadius: "12px",
          padding: "10px 20px",
          fontWeight: "600",
          boxShadow: "0 2px 8px rgba(40, 167, 69, 0.25)",
          border: "none",
          transition: "all 0.3s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow =
            "0 4px 12px rgba(40, 167, 69, 0.35)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 2px 8px rgba(40, 167, 69, 0.25)";
        }}
      >
        <span style={{ fontSize: "20px" }}>🔐</span>
        <span style={{ color: "white" }}>{t("twoFAEnabled")}</span>
        <span
          className="badge bg-white text-success"
          style={{
            fontSize: "10px",
            padding: "3px 8px",
            borderRadius: "6px",
          }}
        >
          ACTIVE
        </span>
      </Button>
    );
  }

  return (
    <Button
      variant="outline-primary"
      onClick={onClick}
      className={`d-flex align-items-center gap-2 ${className}`}
      style={{
        borderRadius: "12px",
        padding: "10px 20px",
        fontWeight: "600",
        borderWidth: "2px",
        transition: "all 0.3s ease",
        background: "linear-gradient(135deg, #fff 0%, #f8f9fa 100%)",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = "0 4px 12px rgba(13, 110, 253, 0.2)";
        e.currentTarget.style.background =
          "linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)";
        e.currentTarget.style.color = "#fff";
        e.currentTarget.style.borderColor = "#0d6efd";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "none";
        e.currentTarget.style.background =
          "linear-gradient(135deg, #fff 0%, #f8f9fa 100%)";
        e.currentTarget.style.color = "#0d6efd";
        e.currentTarget.style.borderColor = "#0d6efd";
      }}
    >
      <span style={{ fontSize: "20px" }}>🔓</span>
      <span>{t("enable2FA")}</span>
      <span
        className="badge bg-warning text-dark"
        style={{
          fontSize: "10px",
          padding: "3px 8px",
          borderRadius: "6px",
          fontWeight: "700",
        }}
      >
        RECOMMENDED
      </span>
    </Button>
  );
};

export default TwoFAButton;
